import React from "react";
import { FiSearch, FiX } from "react-icons/fi";
import { SearchBarProps } from "../../types/messages.types";

/**
 * SearchBar Component
 * Reusable search input with clear functionality
 */
const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  onClear,
  placeholder = "Search conversations...",
  autoFocus = false,
}) => {
  return (
    <div className="relative mb-4">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <FiSearch className="h-5 w-5 text-neutral-400" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className="block w-full pl-10 pr-10 py-2.5 border-2 border-neutral-300 rounded-xl focus:ring-2 focus:ring-[#F56948] focus:border-[#F56948] bg-white dark:bg-neutral-700 dark:border-neutral-600 text-neutral-900 dark:text-white placeholder-neutral-400 transition-all"
      />
      {value && (
        <button
          onClick={onClear}
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
          aria-label="Clear search"
        >
          <FiX className="h-5 w-5 text-neutral-400 hover:text-neutral-600 dark:hover:text-neutral-200 transition-colors" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
